// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YZO5S","option":"styles_option__2ufEP","active":"styles_active__5L2I2"};